/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, OnDestroy, OnInit} from '@angular/core';

import template from './scan-results-page.component.html';
import {AdnTranslateService} from '../../common/filters/adn-translate.service';
import {AdnCheckerService} from '../../../components/util/adn-checker.service';
import {createBufferedFlag, readBufferedFlag} from '../../common/util/template-state';

@Component({
  standalone: false,
  selector: 'adn-scan-results-page',
  template
})
export class ScanResultsPageComponent implements OnInit, OnDestroy {
  readonly bigStatuses = ['BLOCKED', 'INITIALLY_BLOCKED', 'ALLOWED'];

  hide: Record<string, boolean> = {};
  loaded = false;
  private readonly loadedFlag = createBufferedFlag();
  private destroyed = false;
  creativeBlocks: any[] = [];
  data: Record<string, any> = {};
  dataKeys: string[] = [];

  constructor(
    @Inject(AdnCheckerService) private readonly adnChecker: any,
    private readonly adnTranslate: AdnTranslateService,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  get displayLoaded(): boolean {
    return readBufferedFlag(this.loadedFlag, this.loaded, this.cdr, () => !this.destroyed);
  }

  ngOnInit(): void {
    this.doCheck();
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }

  doCheck(): void {
    this.loaded = false;

    this.adnChecker.scanResultsByCreative().then((data: any[]) => {
      this.creativeBlocks = data || [];
    });

    this.adnChecker.scanResults('BLOCKED').then((data: Record<string, any>) => {
      this.loaded = true;
      this.data = data || {};
      this.dataKeys = Object.keys(this.data);
    });
  }

  translateViolation(violation: any): string {
    return this.adnTranslate.transform(violation.text, violation.code, violation.parameters);
  }

  getStatusCount(key: string, bigStatus: string): number {
    return this.data[key]?.[bigStatus]?.length || 0;
  }
}
